export { UIGamePlayerInformationUser } from './UIGamePlayerInformationUser.tsx';
